module.exports = __webpack_public_path__ + "static/media/linda-partitura.be51e10a.png";